import { useCallback, useState, useEffect } from 'react';
import FileDropZone from '../form/fileDropZone';

const ProofOfOwnership = ({
  isSelfHosted = false,
  onFilesChange = () => {},
  onSatoshiChange = () => {},
  onValidationChange = () => {},
}) => {
  const [files, setFiles] = useState([]);
  const [isSatoshiSelected, setIsSatoshiSelected] = useState(false);
  const [isFileUploadSelected, setIsFileUploadSelected] = useState(false);
  const [error, setError] = useState('');

  const validate = useCallback(() => {
    let isValid = true;
    if (!isSelfHosted) {
      setError('');
      onValidationChange(isValid);
      return isValid;
    }

    if (!isFileUploadSelected && !isSatoshiSelected) {
      setError('Please select at least one proof method');
      isValid = false;
    } else if (isFileUploadSelected && files.length === 0) {
      setError('Please upload at least one document');
      isValid = false;
    } else {
      setError('');
    }

    onValidationChange(isValid);
    return isValid;
  }, [
    isSelfHosted,
    files,
    isSatoshiSelected,
    isFileUploadSelected,
    onValidationChange,
  ]);

  useEffect(() => {
    validate();
  }, [validate]);

  const removeFile = (index) => {
    const newFiles = [...files];
    newFiles.splice(index, 1);
    setFiles(newFiles);
    onFilesChange(newFiles);
    if (newFiles.length === 0) {
      setIsFileUploadSelected(false);
    }
    if (newFiles.length === 0 && !isSatoshiSelected) {
      setError('Please select at least one proof method');
    }
  };

  const handleFileUploadCheckbox = (e) => {
    const checked = e.target.checked;
    setIsFileUploadSelected(checked);
    if (!checked) {
      setFiles([]);
    }
    setError('');
  };

  const handleFilesChange = (newFiles) => {
    setFiles(newFiles);
    setIsFileUploadSelected(newFiles.length > 0);
    onFilesChange(newFiles);
    setError('');
  };

  const handleSatoshiChange = (e) => {
    const checked = e.target.checked;
    setIsSatoshiSelected(checked);
    onSatoshiChange(checked);
    setError('');
  };

  return (
    <div className="col-md-12">
      <div className="form-group">
        <label className="form-label mb-0" htmlFor="address">
          Proof of Ownership
          {isSelfHosted && <span className="text-danger">*</span>}
        </label>
        <div className="mb-1">
          <span className="form-note-alt iv-invest-fixed">
            <em>Please select one of the methods</em>
          </span>
          {error && <div className="text-danger small mt-1">{error}</div>}
        </div>
        {isSelfHosted && (
          <div className="d-flex flex-column mb-3" style={{ gap: '10px' }}>
            {/* Option Selection Row */}
            <div className="d-flex align-items-center" style={{ gap: '30px' }}>
              <div className="form-check d-flex">
                <input
                  className="form-check-input me-2"
                  type="checkbox"
                  id="fileUploadOption"
                  checked={isFileUploadSelected}
                  onChange={handleFileUploadCheckbox}
                  style={{
                    width: '1.2em',
                    height: '1.2em',
                    borderColor: '#0074C8',
                    cursor: 'pointer',
                  }}
                />
                <label
                  className="form-check-label d-flex align-items-center"
                  htmlFor="fileUploadOption"
                >
                  File Upload
                </label>
              </div>

              <div className="form-check d-flex">
                <input
                  className="form-check-input me-2"
                  type="checkbox"
                  id="satoshiTestOption"
                  checked={isSatoshiSelected}
                  onChange={handleSatoshiChange}
                  style={{
                    width: '1.2em',
                    height: '1.2em',
                    borderColor: '#0074C8',
                    cursor: 'pointer',
                  }}
                />
                <label
                  className="form-check-label d-flex align-items-center"
                  htmlFor="satoshiTestOption"
                >
                  Satoshi Test
                </label>
              </div>
            </div>
          </div>
        )}
        <FileDropZone
          onFilesChange={handleFilesChange}
          maxFiles={3}
          maxSize={10}
          files={files}
          onRemove={removeFile}
        />
      </div>
    </div>
  );
};

export default ProofOfOwnership;
